export default __webpack_public_path__ + "static/media/red_sq_v2.9ea56743.png";